import { PartialBrief } from '../../../../Types/Brief'

const isDirectEnquiryBrief = ({ hostId, spaceId }: PartialBrief) =>
  typeof hostId === 'string' && typeof spaceId === 'string'

export default isDirectEnquiryBrief
